import { type z } from 'zod';

import { UuidSchema } from '../../common/id/id';
import { makeListQuery } from '../../common/list-query/list-query';
import { DiscountGrantStatusSchema } from '../discount-grant-status/discount-grant-status';

/**
 * The grants viewer's filters (N7) — "what has this member earned, and is any of
 * it still good?".
 *
 * There is no date-range filter and no `expiringBefore`. Expiry is a **status**
 * the sweep writes, not arithmetic a reader does, and offering a date window
 * would invite exactly the second opinion `isSpendableGrantStatus` exists to
 * prevent.
 */
export const DiscountGrantsListQuerySchema = makeListQuery({
  userId: UuidSchema.optional(),
  ruleId: UuidSchema.optional(),
  status: DiscountGrantStatusSchema.optional(),
});

export type DiscountGrantsListQuery = z.infer<typeof DiscountGrantsListQuerySchema>;
